import './index.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check, MessageSquare } from 'react-feather';
import { useProfile } from '../../../../store/Auth/authHooks';

interface props {
  serviceCallId: number;
}

const SupportSuccessMessageContent = ({ serviceCallId }: props) => {
  const profile = useProfile();
  const { t } = useTranslation();

  return (
    <div className="support-message-content">
      <div className="support-message-content-icon">
        <MessageSquare />
        <div className="support-message-content-sub-icon">
          <Check />
        </div>
      </div>
      <div className="support-message-content-title">
        {t('SUPPORT_SUCCESS_MESSAGE', { fullName: profile?.fullName })}
      </div>
      <div className="form-header-subtitle">{t('SERVICE_CALL_CREATED')}</div>
      <div className="form-header-subtitle">
        {t('SERVICE_CALL_NUMBER', { number: serviceCallId })}
      </div>
      <div className="support-message-content-message">
        {t('SUPPORT_SUCCESS_MESSAGE_CONTENT')}
      </div>
    </div>
  );
};

export default SupportSuccessMessageContent;
